import React, { useState } from "react";
import classNames from "classnames";
import Icon from "../../../../components/theme/icon/Icon";
import Text from "../../../../components/theme/text/Text";
import Styles from "../AnswerDetails.module.scss";
import SearchBar from "../SearchBar";
import { BaseProps } from "./base";
import usePortal from "../../../../contexts/PortalContext";

// eslint-disable-next-line import/prefer-default-export
export function SearchBlock(props: BaseProps) {
    const [search, setSearch] = useState<string | undefined>();
    const { isAIEnabled } = usePortal();
    return (
        <div className={classNames(Styles["search-block"], props.className)}>
            <div className={Styles["search-block-header"]}>
                <Icon.Search
                    background="primary"
                    size="xlarge"
                    isRounded
                    variant="primary"
                    className={Styles["search-bar-icon"]}
                />
                <Text textVariant="body-1-semibold" colorVariant="text-title">
                    Search
                </Text>
            </div>
            <Text className={Styles["search-block-caption"]} textVariant="body-2-regular" colorVariant="body-secondary">
                Search for an article
                {isAIEnabled ? " or ask a question using AI" : "" }
                .
            </Text>
            <SearchBar search={search} setSearch={value => setSearch(value)} />

        </div>
    );
}
